@if (creditorBasicDataWidgetData && initialized) {
    <mvs-widget [widgetData]="creditorBasicDataWidgetData">
    </mvs-widget>
}